import { Component } from '@angular/core';
import { TranslationService } from './translate';
import { AppService } from './app.service';
import { GoogleAnalyticsEventsService } from "./google-analytics-events.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'web-new';

	selectedLang = "en";
	selectedLangDir = "en";

	result_calculated = 0;

	constructor(public appState: AppService, private _translate: TranslationService, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) {
		this.googleAnalyticsEventsService.eventCount().subscribe(
	        data => {
	        	this.result_calculated = data["Result-Calculated-Inheritance"];
	        },
	        error => console.log(error)
      	);
	}

	ngOnInit() {
		// Translation
		var settings = localStorage.getItem('settings');
		var settingsLocal = JSON.parse( settings );

		if( settings != null ) {
			if( settingsLocal.lang == "English" ) {
				settingsLocal.lang = "en";
			}
			this._translate.use(settingsLocal.lang);
			this.selectedLang = settingsLocal.lang;	
			this.selectedLangDir = settingsLocal.dir;

		} else {
			this._translate.use("en");
			this.selectedLang = "en";
			this.selectedLangDir = "ltr";
		}
		
	}

}

